export enum DATA_PROVIDER_NAME {
  FUNDATA = 'Fundata',
  PREQIN = 'Preqin',
  REFINITIV = 'Refinitiv',
  FACTSET = 'Factset',
}
